import { render, staticRenderFns } from "./LocalYamlEditor.vue?vue&type=template&id=683ccaa4&scoped=true&"
import script from "./LocalYamlEditor.vue?vue&type=script&lang=js&"
export * from "./LocalYamlEditor.vue?vue&type=script&lang=js&"
import style0 from "./LocalYamlEditor.vue?vue&type=style&index=0&id=683ccaa4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ccaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VSwitch})
